"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareConfigDataForSaving = exports.getConfigFromSnapshot = exports.defaultConfig = exports.configScheme = exports.DEFAULT_CYCLE_START = void 0;
const firestore_1 = require("./firestore");
exports.DEFAULT_CYCLE_START = '2021-01-18T00:00:00Z';
exports.configScheme = {
    project_cycle_start: 'date',
    project_cycle_duration_weeks: 'number',
    cooldown_duration_weeks: 'number',
    bugfix_monday_recurrence_weeks: 'number',
    components: 'array',
};
exports.defaultConfig = {
    project_cycle_start: new Date(exports.DEFAULT_CYCLE_START).toISOString(),
    project_cycle_duration_weeks: 6,
    cooldown_duration_weeks: 2,
    bugfix_monday_recurrence_weeks: 2,
    components: [],
};
function getConfigFromSnapshot(snapshot) {
    return firestore_1.fromScheme(exports.configScheme, snapshot, exports.defaultConfig);
}
exports.getConfigFromSnapshot = getConfigFromSnapshot;
function prepareConfigDataForSaving(firestore, key, value) {
    return firestore_1.toFirestore(firestore, value, exports.configScheme[key]);
}
exports.prepareConfigDataForSaving = prepareConfigDataForSaving;
//# sourceMappingURL=config.js.map